var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/HubManagement/Attribute.ts";
import "core-js/modules/es.array.join.js";
import { ApiCallService } from '@gmini/api-call-service';
import * as t from 'io-ts';
import { ApiDomain } from '../domain';
export var Attribute;

(function (_Attribute) {
  var domain = ApiDomain.domain('HubManagementAttribute', {
    name: "domain",
    sid: "ub5u5n"
  });
  var Data = _Attribute.Data = t.intersection([t.type({
    id: t.number,
    name: t.string,
    deleted: t["boolean"]
  }), t.partial({
    description: t.union([t["null"], t.string])
  })]);
  var attributeValueType = _Attribute.attributeValueType = 'AttributeValue';
  var ValueInfo = _Attribute.ValueInfo = t.type({
    id: t.number,
    name: t.string,
    deleted: t["boolean"]
  });
  var Value = _Attribute.Value = t.intersection([ValueInfo, t.type({
    attributeId: t.number,
    type: t.literal(attributeValueType),
    parentGroupId: t.union([t["null"], t.number])
  })]);
  var attributeGroupType = _Attribute.attributeGroupType = 'AttributeGroup';
  var Group = _Attribute.Group = t.type({
    id: t.number,
    attributeId: t.number,
    type: t.literal(attributeGroupType),
    name: t.string,
    deleted: t["boolean"],
    total: t.number
  });
  var fetchRes = _Attribute.fetchRes = t.intersection([Data, t.partial({
    children: t.array(t.union([Value, Group]))
  })]);
  var fetchAttribute = _Attribute.fetchAttribute = ApiCallService.create({
    name: 'fetchAttribute',
    getKey: ['attrId'],
    result: fetchRes,
    parentDomain: domain
  });
  var fetchPopulatedRes = _Attribute.fetchPopulatedRes = t.intersection([Data, t.partial({
    children: t.array(t.union([Value, t.intersection([Group, t.partial({
      children: t.array(Value)
    })])]))
  })]);
  var fetchAttributePopulated = _Attribute.fetchAttributePopulated = ApiCallService.create({
    name: 'fetchAttributePopulated',
    getKey: ['attrId'],
    result: fetchPopulatedRes,
    parentDomain: domain
  });
  var fetchAttributeValuesRes = _Attribute.fetchAttributeValuesRes = t.type({
    attributeValues: t.array(t.intersection([ValueInfo, t.type({
      attribute: Data,
      group: t.union([t["null"], Group])
    })]))
  });
  var fetchAttributeValues = _Attribute.fetchAttributeValues = ApiCallService.create({
    name: 'fetchAttributeValues',
    getKey: function getKey(_ref) {
      var valueIds = _ref.valueIds;
      return valueIds.join(',');
    },
    result: fetchAttributeValuesRes,
    parentDomain: domain
  });
  var fetchAttributeList = _Attribute.fetchAttributeList = ApiCallService.create({
    name: 'fetchAttributeList',
    getKey: function getKey() {
      return '0';
    },
    result: t.array(Data),
    parentDomain: domain
  });
})(Attribute || (Attribute = {}));